import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import SectorCommentary from "@/pages/benchmark/SectorCommentary";
import RSectorCommentary from "@/pages/r-benchmark/RSectorCommentary";
import DistSectorCommentary from "@/pages/dist-benchmark/DistSectorCommentary";
import MmSectorCommentary from "@/pages/mm-benchmark/MmSectorCommentary";

export default function CommentaryEditorSection() {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Sector Commentary</CardTitle>
        <CardDescription>
          Shared investment commentary across all portfolio suites
        </CardDescription>
      </CardHeader>
      <CardContent>
        <Tabs defaultValue="p">
          <TabsList>
            <TabsTrigger value="p">P Portfolios</TabsTrigger>
            <TabsTrigger value="r">R Portfolios</TabsTrigger>
            <TabsTrigger value="dist">Dist Portfolios</TabsTrigger>
            <TabsTrigger value="mm">Money Markets</TabsTrigger>
          </TabsList>
          <TabsContent value="p" className="mt-4"><SectorCommentary /></TabsContent>
          <TabsContent value="r" className="mt-4"><RSectorCommentary /></TabsContent>
          <TabsContent value="dist" className="mt-4"><DistSectorCommentary /></TabsContent>
          <TabsContent value="mm" className="mt-4"><MmSectorCommentary /></TabsContent>
        </Tabs>
      </CardContent>
    </Card>
  );
}
